<template>
    <div>
<!--        @click-right="addFleet()"-->
        <van-nav-bar
            title="我的车辆"
            left-text=""
            right-text="筛选"
            left-arrow
            fixed
            @click-left="back()"
            @click-right="openSearch()"
            v-if="show"
        />

        <van-nav-bar
                :title="title"
                left-text=""
                left-arrow
                fixed
                @click-left="showpop=false"
                v-if="showpop"
                z-index="9999"
        />




        <div class="contentwarp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh"  >
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                >
<!--                    <van-swipe-cell v-for="item in list" :key="item.id" class="swipewarp">-->
                    <div v-for="item in list" :key="item.id"  class="swipewarp">
                        <van-cell  @click="editFleet(item)" >
                            <van-row gutter="20">
                                <van-col span="7" style="padding-left: 5px">{{item.carNum}}</van-col>
                                <van-col span="6">{{item.dirver}}</van-col>
                                <van-col span="8">{{item.phone}}</van-col>
                                <van-col span="3" style="text-align: center"><van-icon name="arrow" /></van-col>
                            </van-row>
                        </van-cell>
                        <!--                        <template #right>-->
                        <!--                            <van-button plain  type="danger" text="删除" @click="remove(item.id)"/>-->
                        <!--                        </template>-->
                        <!--                    </van-swipe-cell>-->
                    </div>


                </van-list>
            </van-pull-refresh>
        </div>


        <van-popup v-model="searchShowpop" position="right" :style="{ height: '100%', width:'80%'}" >
            <van-nav-bar
                    title="筛选"
            />
            <div class="searchwarp">
                <van-field v-model="value" label="关键字"  placeholder="车号\姓名\手机号码"  autocomplete="off"/>



                <van-row gutter="20" style="margin-top:20px">
                    <van-col span="8" offset="4">
                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px" @click="resetSearch()">
                            重置
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px" @click="onSearch()">
                            确定
                        </van-button>
                    </van-col>
                </van-row>

            </div>
<!--                    <van-sticky>-->
<!--                        <van-search-->
<!--                                class="searchwarp"-->
<!--                                v-model="value"-->
<!--                                placeholder="车号\姓名\手机号码"-->
<!--                                @blur="onSearch"-->
<!--                        >-->
<!--            &lt;!&ndash;                <template #action>&ndash;&gt;-->
<!--            &lt;!&ndash;                    <div @click="onSearch">搜索</div>&ndash;&gt;-->
<!--            &lt;!&ndash;                </template>&ndash;&gt;-->
<!--                        </van-search>-->
<!--                    </van-sticky>-->
        </van-popup>

        <van-popup v-model="showpop" position="right" :style="{ height: '100%', width:'100%'}" >
            <div class="editwarp">
                <van-field v-model="carInfo.carNum" label="车牌号码"  placeholder="请输入车牌号码"  autocomplete="off"/>
                <van-field v-model="carInfo.dirver" label="驾驶员姓名"  placeholder="请输入驾驶员姓名"  autocomplete="off"/>
                <van-field v-model="carInfo.phone" label="手机号码"  placeholder="请输入手机号码"  autocomplete="off"/>

                <van-row gutter="20" style="margin-top:20px" v-show="carInfo.id!=''">
                    <van-col span="8" offset="4">
                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px;" @click="remove(carInfo.id)">
                            删除
                        </van-button>
                    </van-col>
                    <van-col span="8">
                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px;" @click="saveFleet()">
                            保存
                        </van-button>
                    </van-col>
                </van-row>
                <van-row gutter="20" style="margin-top:20px"  v-show="carInfo.id==''">
                    <van-col  span="8" offset="8">
                        <van-button  block size="small" type="info" native-type="submit" style="font-size: 16px;" @click="saveFleet()">
                            保存
                        </van-button>
                    </van-col>
                </van-row>



            </div>
        </van-popup>

        <van-button class="closebutton" block  size="small" type="info" native-type="submit" style="font-size: 16px;width:100px;margin:auto" @click="addFleet()">
            创建
        </van-button>
    </div>
</template>

<script>
    import {NavBar, Toast, Cell, Button, Icon, Field, Dialog} from 'vant';
    import {List } from 'vant';
    import {Search  } from 'vant';
    import { Col, Row } from 'vant';
    import {SwipeCell } from 'vant';
    import {Popup } from 'vant';
    import {PullRefresh } from 'vant';
    import {Sticky } from 'vant';
    import service from '../../server/index'

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row .name]: Row ,
            [Cell.name]: Cell,
            [SwipeCell.name ]:SwipeCell,
            [Button.name]:Button,
            [Popup.name]: Popup,
            [Icon.name]:Icon,
            [Field.name]:Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky
        },
        data(){
          return {
              value:"",
              show:true,//nav bar
              list: [
                  // {"id":"11","carNum":"苏B12345","dirver":"张三","phone":"13300000001"},
                  // {"id":"22","carNum":"鲁B12345","dirver":"王五","phone":"13300000001"},
                  // {"id":"33","carNum":"浙A12345","dirver":"赵六","phone":"13300000001"}
                  ],
              loading:true,
              finished: false,
              showpop:false,
              searchShowpop:false,
              //编辑车辆
              carInfo:{
                  "id":"",
                  "carNum":"",
                  "dirver":"",
                  "phone":""
              },
              //刷新
              isLoading:false,
              page:1
          }
        },
        mounted() {
            this.onLoad();
        },
        methods:{
            back(){
                this.$router.replace("/Home/HomeMenu")
            },
            openSearch(){
                this.searchShowpop=true;
            },
            resetSearch(){
              this.value="";
            },

            onSearch(){
                this.searchShowpop=false;
                this.list = [];
                this.page = 1;
                this.onLoad();
            },
            onLoad(){

                let param = {
                    query:this.value,
                    userId:localStorage.getItem("userId"),
                    limit:20,
                    page:this.page
                }
                service.getTruckList(param).then((res)=>{
                    if(res.code=="200"){
                        if(res.data.length>0){
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push({
                                    "id":res.data[i].deliveryTruckId,
                                    "carNum":res.data[i].truckNo,
                                    "dirver":res.data[i].driverName,
                                    "phone":res.data[i].driverPhoneNumber
                                });
                            }
                            this.page++
                        }else{
                            this.finished = true;
                        }


                            // 加载状态结束
                        this.loading = false;
                        this.isLoading=false;
                    }else{
                        this.loading = false;
                        this.finished = true;
                        this.isLoading=false;
                        Toast(res.message)
                    }

                }).catch((res)=>{
                    this.loading = false;
                    this.finished = true;
                    Toast(res.message)
                });
            },
            addFleet(){
                this.title = "创建车辆"
                this.carInfo={"id":"", "carNum":"", "dirver":"", "phone":""}
                this.showpop = true;
            },
            editFleet(item){
                this.title = "车辆信息"
                this.carInfo={"id":item.id, "carNum":item.carNum, "dirver":item.dirver, "phone":item.phone}
                this.showpop = true;
            },
            saveFleet(){
                if(this.carInfo.carNum==""){
                    Toast("请输入车牌号码")
                    return false;
                }

                if(this.carInfo.dirver==""){
                    Toast("请输入驾驶员姓名")
                    return false;
                }
                if(this.carInfo.phone==""){
                    Toast("请输入驾驶员手机号码")
                    return false;
                }

                if(this.carInfo.id==""){
                    let param = {
                        "deliveryTruckId":"",
                        "truckNo": this.carInfo.carNum,
                        "driverName":this.carInfo.dirver,
                        "driverPhoneNumber":this.carInfo.phone,
                        "deliveryId":localStorage.getItem("deliveryId"),
                        "userId":localStorage.getItem("userId"),
                    }
                    service.insertTruck(param).then((res)=>{
                        if(res.code=="200"){
                            this.showpop = false;
                            this.page = 1;
                            this.list = [];
                            this.onLoad();
                        }else{
                            Toast(res.msg)
                        }

                    }).catch((res)=>{
                        Toast(res.message)
                    });
                }else{
                    let param = {
                        "deliveryTruckId":this.carInfo.id,
                        "truckNo": this.carInfo.carNum,
                        "driverName":this.carInfo.dirver,
                        "driverPhoneNumber":this.carInfo.phone,
                        "deliveryId":localStorage.getItem("deliveryId"),
                        "userId":localStorage.getItem("userId"),
                    }
                    service.updateTruck(param).then((res)=>{
                        if(res.code=="200"){
                            this.showpop = false;
                            this.page = 1;
                            this.list = [];
                            this.onLoad();
                        }else{
                            Toast(res.msg)
                        }

                    }).catch((res)=>{
                        Toast(res.message)
                    });
                }
            },
            onRefresh(){
                this.onLoad();

            },
            remove(id){
                Dialog.confirm({
                    title: '提示消息',
                    message: '确定删除该记录吗？',
                    confirmButtonColor:"#6685a4"
                })
                    .then(() => {
                        let param = {
                            "deliveryTruckId":id,
                        }
                        service.deleteTruck(param).then((res)=>{
                            if(res.code=="200"){
                                this.showpop = false;
                                this.page = 1;
                                this.list = [];
                                this.onLoad();
                            }else{
                                Toast(res.msg)
                            }

                        }).catch((res)=>{
                            Toast(res.message)
                        });
                    })
                    .catch(() => {
                        // on cancel
                    });
            },


        }
    }
</script>

<style scoped>
    .van-popup{
        background-color: #f7f8fa;
    }
    .searchwarp{
        /*margin-top: 46px;*/
    }
    .editwarp{
        width:100%;
        margin: 50px auto;
    }

    .swipewarp{
        height: 44px;
        font-size: 14px
    }

    .contentwarp{
        margin-top: 46px;
        height: calc(100vh - 100px);
    }
    /deep/ .van-nav-bar .van-icon,
    /deep/ .van-nav-bar__text ,
    /deep/ .van-calendar__day--middle,
    .van-icon.van-icon-arrow{
        color: #6685a4 ;
    }
    /*/deep/ .van-ellipsis{*/
    /*    color: #EE0A24;*/
    /*}*/
    /*/deep/ .van-nav-bar .van-icon{*/
    /*    color: #EE0A24;*/
    /*}*/

    /*/deep/ .van-nav-bar__text{*/
    /*    color: #EE0A24;*/
    /*}*/
    /deep/ .van-button--info {
        background-color: #6685a4 ;
        border: 1px solid #6685a4 ;
    }
    .van-button--plain.van-button--danger {
        color: #ffffff;
        border: 1px solid #6685a4 ;
        background: #6685a4 ;
    }

    /deep/ .van-button--info ,
    /deep/ .van-button--danger{
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color:#6685a4;

    }

    .closebutton{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 50px;
        height: 50px;
        width: 100% !important;
    }
</style>